import ChecklistIcon from '@mui/icons-material/Checklist';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MeinBereichButton, MeinBereichPaper } from '../../../../components/ui-component/mein-bereich/MeinBereichComponents';
import { ANTRAGS_STATUS } from '../../../../lib/constants/constant';
import { PAGES_URLS } from '../../../../lib/constants/routes';
import { enumT, getFieldNamefromDataPath } from '../../../../utils/helper';

// import Schemas
import AntragSchema from '../../../../lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

function AntraegeInForderung() {
	const navigate = useNavigate();
	return (
		<>
			<MeinBereichPaper titleIcon={<ChecklistIcon sx={{ color: 'black' }} />} title={'Funktionen'}>
				<MeinBereichButton
					buttonName='Verträge in Förderung ansehen'
					onClick={() => {
						navigate(`${PAGES_URLS.MeineFoerderung}`, {
							state: {
								filter: {
									field: getFieldNamefromDataPath(P.Status_Status.path),
									operator: 'contains',
									value: enumT(ANTRAGS_STATUS.InFoerderung),
								},
							},
						});
					}}
				/>
				<MeinBereichButton
					buttonName='Vertrag unterschreiben'
					onClick={() => {
						navigate(`${PAGES_URLS.MeineFoerderung}`, {
							state: {
								filter: {
									field: getFieldNamefromDataPath(P.Status_Status.path),
									operator: 'contains',
									value: enumT(ANTRAGS_STATUS.ZuwendungsvertragErstellt),
								},
							},
						});
					}}
				/>
				<MeinBereichButton
					buttonName='Abgeschlossene Verträge ansehen'
					onClick={() => {
						navigate(`${PAGES_URLS.MeineFoerderung}`, {
							state: {
								filter: {
									field: getFieldNamefromDataPath(P.Status_Status.path),
									operator: 'contains',
									value: enumT(ANTRAGS_STATUS.Abgeschlossen),
								},
							},
						});
					}}
				/>
			</MeinBereichPaper>
		</>
	);
}

export default AntraegeInForderung;
